import { stores } from "../endpoints/stores.endpoints";
import $axios from "../http/accessor";

const StoresService = {
  getALLStores: (page: number, count: number, search?: string) => {
    return $axios.get(stores.all_stores, {
      params: {
        page,
        count,
        search,
      },
    });
  },

  getOneStore: (id: number) => {
    return $axios.get(stores.get_one_store(id));
  },

  deleteStore: (id: number) => {
    return $axios.delete(stores.detele_store(id));
  },

  updatePercentage: (id: number, formData: FormData) => {
    return $axios.put(stores.update_percent(id), formData);
  },

  getStoresForMap: () => {
    return $axios.get(stores.stores_for_map);
  },
};

export default StoresService;
